import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@mui/material'

import { NewModel } from '@components/NewModel'

import { ObjectShortDTO } from '@types'

import { ModelType } from '@gantt/components/GanttCreateOrEdit'

type GeneralFormProps = {
  isLoading: boolean
  modelType: ModelType
  objects: ObjectShortDTO[] | undefined
}

export const GeneralForm = ({ modelType }: GeneralFormProps) => {
  const { t } = useTranslation()

  return (
    <Box mb={2} p={1} pb={0}>
      <Grid container justifyContent='space-between'>
        <Grid item>
          <Typography variant='h5'>{t(`ganttCreate.${modelType}`)}</Typography>
        </Grid>
      </Grid>
      <NewModel loading={false} />
    </Box>
  )
}
